import { styled } from 'linaria/react';
export const TabHeader = /*#__PURE__*/styled("li")({
  name: "TabHeader",
  class: "tyu2497",
  vars: {
    "tyu2497-0": [({
      isActive
    }) => isActive ? 'white' : 'inherit'],
    "tyu2497-1": [({
      isActive
    }) => isActive ? '3px solid #e95801' : '3px solid transparent']
  }
});
export const TabHeaderList = /*#__PURE__*/styled("ul")({
  name: "TabHeaderList",
  class: "t1o3cvgf",
  vars: {
    "t1o3cvgf-0": [props => props.justify || 'flex-start']
  }
});